/** @file Built-in profiles pixel16, hd and their side twins (design 4.5, 17.7, 20.2). */
import type { Profile, ProfileCamera } from '@zilo/pose3d-format/types/profile';

/** The iso camera of pixel16 and hd: tilted 30 degrees, templates cover 20..40. */
const ISO: ProfileCamera = { kind: 'ortho', pitch: 30, pitchRange: [20, 40] };
/** The side camera of the `-side` twins (CR-002): level, a plain 2D side view, templates cover 0..10. */
const SIDE: ProfileCamera = { kind: 'ortho', pitch: 0, pitchRange: [0, 10] };

const pixel16 = { pixelsPerUnit: 16, snap: 'pixel', sampling: 'nearest', cutDefault: 'cut', halfPixel: true } as const;
const hd = { pixelsPerUnit: 360, snap: 'none', sampling: 'linear', cutDefault: 'scale', halfPixel: false } as const;

/**
 * Built-in profiles by id; all use the default z scales (rotate 1, view 1 / cos pitch). `<id>-side` is `<id>` with
 * the side camera, picked by `template.instantiate.scope.camera: 'side'`.
 */
export const BUILTIN_PROFILES: Readonly<Record<'pixel16' | 'hd' | 'pixel16-side' | 'hd-side', Profile>> = {
  pixel16: { id: 'pixel16', ...pixel16, camera: { ...ISO, pitchRange: [...ISO.pitchRange] } },
  hd: { id: 'hd', ...hd, camera: { ...ISO, pitchRange: [...ISO.pitchRange] } },
  'pixel16-side': { id: 'pixel16-side', ...pixel16, camera: { ...SIDE, pitchRange: [...SIDE.pitchRange] } },
  'hd-side': { id: 'hd-side', ...hd, camera: { ...SIDE, pitchRange: [...SIDE.pitchRange] } },
};
